// AppointmentHeader.jsx
import React from "react";
import { Button, DatePicker } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

function convertDateFormat(dateString) {
  // Split by forward slash instead of hyphen
  const parts = dateString?.split("/");

  // Rearrange from DD/MM/YYYY to MM/DD/YYYY
  return `${parts[1]}/${parts[0]}/${parts[2]}`;
}

export const AppointmentHeader = ({ selectedDate, setSelectedDate }) => {
  const onPick = (d) => {
    if (!d) return;
    setSelectedDate(d.toDate());
  };



  const selectToday = () => setSelectedDate(new Date());
  const selectTomorrow = () => setSelectedDate(dayjs().add(1, "day").toDate());

  return (
    <div className="w-[70%] flex justify-between items-center mb-4">
      <span className="font-inter text-[14px] leading-[20px] font-medium text-black">
        APPOINTMENTS
      </span>
      <div className="flex items-center gap-x-2">
        <DatePicker
          format="MMM DD, YYYY"
          value={dayjs(selectedDate)}
          onChange={onPick}
          prefix={<CalendarOutlined className="text-accent text-[18px] mr-1" />}
          suffixIcon={null}
          variant="borderless"
          allowClear={false}
          className="text-lightText w-[160px]"
        />
        <Button
          className="bg-accent text-white font-inter text-[14px] leading-[20px] font-medium"
          onClick={selectToday}
        >
          Today
        </Button>
        <Button
          className="bg-white text-accent font-inter text-[14px] leading-[20px] font-medium"
          onClick={selectTomorrow}
        >
          Tomorrow
        </Button>
      </div>
    </div>
  );
};
